import { documentsFetch, notesFetch, kbArticlesFetch } from '../../functions/documents/index.js'

const _restoreFromHash = (el, s) => {
  const root = s.root
  if (root.editorDoc) return // already loaded via click
  if (typeof window === 'undefined') return
  const hash = window.location.hash.slice(1)
  if (!hash) return
  const params = new URLSearchParams(hash)
  const docId = params.get('doc')
  const noteId = params.get('note')
  const kbId = params.get('kb')

  const tryRestore = () => {
    if (docId) {
      const doc = (root.documents || []).find((d) => String(d.id) === docId)
      if (doc) {
        const content = doc.content && typeof doc.content === 'object' ? doc.content : { blocks: [] }
        root.update({ editorDoc: { id: doc.id, title: doc.title, content }, editorMode: 'view', activeSection: 'editor' })
        return true
      }
    }
    if (noteId) {
      const note = (root.notes || []).find((n) => String(n.id) === noteId)
      if (note) {
        const content = note.content && typeof note.content === 'object' ? note.content : { blocks: [] }
        root.update({ selectedNoteId: note.id, editorDoc: { id: note.id, title: note.title || 'Untitled note', content, source: note.source || 'member', author: note.author }, editorMode: 'view', activeSection: 'editor' })
        return true
      }
    }
    if (kbId) {
      const kb = (root.kbArticles || []).find((a) => String(a.id) === kbId)
      if (kb) {
        const content = kb.content && typeof kb.content === 'object' ? kb.content : { blocks: [] }
        root.update({ editorDoc: { id: kb.id, title: kb.title, content, source: 'kb' }, editorMode: 'view', activeSection: 'editor' })
        return true
      }
    }
    return false
  }

  if (tryRestore()) return
  // Data may not be fetched yet — retry a few times
  let attempts = 0
  const t = setInterval(() => {
    if (tryRestore() || ++attempts > 15) clearInterval(t)
  }, 300)
  el._editorRestoreTimer = t
}

export const editor = {
  extends: 'AppPage',
  metadata: (el, s) => {
    const doc = s.root?.editorDoc
    const title = doc?.title || 'Editor'
    return { title: title + ' / Documents / Symbols Workspace' }
  },

  fetch: [
    documentsFetch,
    notesFetch,
    kbArticlesFetch
  ],

  onCreate: (el, s) => _restoreFromHash(el, s),
  onRemove: (el) => { if (el._editorRestoreTimer) clearInterval(el._editorRestoreTimer) },

  DocsSidebar: {},
  EditorMain: {}
}
